var exports = {
  "S": "x8b4e8595--0de734--pagination-sentinel",
};

module.exports = exports;
